import axios from 'axios';
import authToken from '../authToken';
import cfac22 from '../../cfac22';

export default function getAllRafflesOfPartner(partnerId) {
  return new Promise((resolve, reject) => {
    authToken()
      .then((token) => {
        axios
          .get(`${cfac22('API_HOST_V2')}/raffle/getAllRafflesOfPartner?partnerId=${partnerId}`, {
            headers: { authorization: `Bearer ${token}` },
          })
          .then((result) => {
            resolve(result.data.result);
          })
          .catch((error) => {
            //console.log("ERROR: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        reject(error.data.error);
      });
  });
}
